var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMagnifyingGlass = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9172 36.6207C65.9172 52.8007 52.8007 65.9172 36.6207 65.9172C20.4407 65.9172 7.32414 52.8007 7.32414 36.6207C7.32414 20.4407 20.4407 7.32414 36.6207 7.32414C52.8007 7.32414 65.9172 20.4407 65.9172 36.6207ZM60.4372 65.6156C60.0739 65.2523 59.4953 65.2247 59.0898 65.5402C52.8865 70.3668 45.0893 73.2414 36.6207 73.2414C16.3956 73.2414 0 56.8457 0 36.6207C0 16.3956 16.3956 0 36.6207 0C56.8457 0 73.2414 16.3956 73.2414 36.6207C73.2414 45.089 70.367 52.886 65.5406 59.0893C65.2251 59.4948 65.2528 60.0733 65.6161 60.4366L87.4274 82.248C88.8575 83.6781 88.8575 85.9968 87.4274 87.4269C85.9973 88.857 83.6786 88.857 82.2485 87.4269L60.4372 65.6156Z",
    fill: "#4F5A5F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMagnifyingGlass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/magnifyingGlass.286b511262c88de3533993ccd26ac49a.svg";